import { StyledSummaryTableCell, SummaryHeader } from '../../../../components';
import { useFormContext } from 'react-hook-form';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

import type { IUpdatePersonnelResponse } from '../../../../types';
import type { FC } from 'react';

interface IPersonnelProps {
    setStep: (step: number) => void;
}

export const PersonnelSummary: FC<IPersonnelProps> = ({ setStep }) => {
    const formContext = useFormContext();
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    const personnel: Array<IUpdatePersonnelResponse> = formContext.getValues('allPersonnel');

    const onStepClick = () => setStep(4);

    return (
        <div>
            <SummaryHeader isLink onLink={onStepClick}>
                {localization.translate('personnelSummary.stepLink')}
            </SummaryHeader>

            {/* NO PERSONNEL MESSAGE */}
            {personnel?.length === 0 && (
                <span className={'font-medium dark:text-gray-200'}>
                    {localization.translate('personnelSummary.noPersonnelMessage')}
                </span>
            )}

            {/* PERSONNEL TABLE */}
            {personnel?.length !== 0 && (
                <table className={'mt-1'}>
                    <thead>
                        <tr>
                            <StyledSummaryTableCell isHeader>
                                {localization.translate('personnelSummary.titleHeader')}
                            </StyledSummaryTableCell>
                            <StyledSummaryTableCell isHeader isNumeric>
                                {localization.translate('personnelSummary.regularHeader')}
                            </StyledSummaryTableCell>
                            <StyledSummaryTableCell isHeader isNumeric>
                                {localization.translate('personnelSummary.overtimeHeader')}
                            </StyledSummaryTableCell>
                        </tr>
                    </thead>
                    <tbody>
                        {personnel.map((p) => {
                            return (
                                <tr key={p.itemId}>
                                    <StyledSummaryTableCell>{p.title}</StyledSummaryTableCell>
                                    <StyledSummaryTableCell isNumeric>{p.regular}</StyledSummaryTableCell>
                                    <StyledSummaryTableCell isNumeric>{p.overtime}</StyledSummaryTableCell>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};